import { render, staticRenderFns } from "./Envelop.vue?vue&type=template&id=48841d84&scoped=true&"
import script from "./Envelop.vue?vue&type=script&lang=js&"
export * from "./Envelop.vue?vue&type=script&lang=js&"
import style0 from "./Envelop.vue?vue&type=style&index=0&id=48841d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48841d84",
  null
  
)

component.options.__file = "Envelop.vue"
export default component.exports